module.exports = __webpack_public_path__ + "media/images/preview/arrow-right-top-2e4b333ff2f12199658c6bec4a7453ee.svg";